import * as _ from 'lodash'
import { Observable, throwError } from 'rxjs'
import { switchMap } from 'rxjs/operators'

import { Workspace, DataStoreOptions } from '@skinsoft/types'
import { fetch } from '@skinsoft/network'
import { EntityDataStore } from '@skinsoft/entity-data-store'
import { bus } from '@skinsoft/bus'

declare const FALLBACK_LOCALE;

export class WorkspaceDataStore extends EntityDataStore<Workspace> {
    public static getInstance() {
        if (!WorkspaceDataStore.instance) {
            WorkspaceDataStore.instance = new WorkspaceDataStore();
        }

        return WorkspaceDataStore.instance;
    }

    public static install(Vue) {
        Vue.prototype.$workspaceDataStore = WorkspaceDataStore.getInstance();
    }

    private static instance: WorkspaceDataStore = null as any;

    private _currentWorkspace: Workspace
    private _workspaceList: Workspace[] = []

    constructor() {
        super('workspace');
    }

    public update(id: string, body: Partial<Workspace>, endpointOverride?: string, ignoreCachedStatus: boolean = false) {
        return throwError("Cannot update workspace")
    }

    public searchAll(queryText: string | null, sortObject: any, pageSize: number = 15, types?: string[], page: number = 0, advancedSearches: any = null, filteredIds?: string[], pathAndValueToCheck?: any, searchEndpointOverride: string | null = null, options: DataStoreOptions = {}) {
        return throwError("Cannot search workspaces")
    }

    public searchOneWithText(queryText: string, types: string[]): Promise<Workspace> {
        throw new Error("Cannot search workspaces")
    }

    public searchTitles(types: string[], filterText: string, pageNumber: number = 0, defaultFilter: string = "", size: number = 10, filterIds?: string[], esPath?: any, language: string = FALLBACK_LOCALE) {
        return throwError("Cannot search workspaces")

    }

    public create(createBody?: Partial<Workspace>, body?: Partial<Workspace>): Observable<Workspace> {
        return throwError("Cannot create workspaces")
    }

    public duplicate(entityToDuplicateId: string, createBody?: Partial<Workspace>, body?: Partial<Workspace>) {
        return throwError("Cannot duplicate workspace")
    }

    public delete(id: string) {
        return throwError("Cannot delete workspace")
    }

    public get currentWorkspace() {
        return this._currentWorkspace.id
    }

    public set currentWorkspace(id: string) {
        const nextWorkspace = this.workspaceList.find(workspace => workspace.id === id)
        if (nextWorkspace) {
            this._currentWorkspace = nextWorkspace
            fetch
            .api(
                `/institution/byWorkspaces?workspaces=${[
                    this.currentWorkspace,
                ]}`,
                { method: 'GET' },
            )
            .pipe(
                switchMap(institution => {
                    localStorage.setItem(
                        'institution',
                        _.get(institution, '_embedded.institution[0].id'),
                    )
                    return fetch.api(
                        `/users/token?institutionId=${_.get(
                            institution,
                            '_embedded.institution[0].id',
                        )}&workspaceId=${this.currentWorkspace}`,
                        {
                            method: 'GET',
                        },
                    )
                }),
            )
            .subscribe((response: any) => {
                localStorage.setItem('token', response.token)
                fetch.registerToken(response.token)
                localStorage.setItem('workspace', this.currentWorkspace)
                bus.emit('change_current_workspace', this.currentWorkspace)
            })
        }
    }

    public get currentWorkspaceInfo() {
        return _.cloneDeep(this._currentWorkspace)
    }

    public get workspaceList(): Workspace[] {
        return _.cloneDeep(this._workspaceList) ?? []
    }

    public set workspaceList(workspaceList: Workspace[]) {
        this._workspaceList = _.cloneDeep(workspaceList)
    }
}
